<template>
  <div class="global-header">
    <div class="header-left">
      <el-tooltip content="刷新页面" placement="bottom">
        <el-icon class="refresh-icon" @click="refreshPage">
          <Refresh />
        </el-icon>
      </el-tooltip>
    </div>
    <div class="header-right">
      <RightContent />
    </div>
  </div>
</template>

<script>
import RightContent from './RightContent.vue'
import { Refresh } from '@element-plus/icons-vue'

export default {
  name: 'GlobalHeader',
  components: {
    RightContent,
    Refresh
  },
  methods: {
    refreshPage() {
      if (this.$bus) {
        this.$bus.$emit('refreshPage', this.$route.path)
      } else {
        // 如果没有 $bus，直接刷新页面
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped>
.global-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 16px;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
}

.refresh-icon {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
  transition: color 0.3s;
}

.refresh-icon:hover {
  color: #409eff;
}

.header-right {
  display: flex;
  align-items: center;
}
</style>

